import { gql } from '@apollo/client'

export default gql(`
    mutation updateUserDeactivationConfig($input: DeactivationConfigInput $project: String) {
        updateUserDeactivationConfig(
            input: $input
            project: $project
        ) {
            id
            items {
                id
                name
                users
            }
        }
    }
`)
